/**
 * Security Page
 * Security features and compliance information
 */

import { SecuritySection } from '@/components/sections/security';
import { CtaSection } from '@/components/sections/cta';

export function SecurityPage() {
  return (
    <>
      <div className="pt-24">
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Enterprise-Grade Security</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Zero prompt storage, SOC 2 compliance, and end-to-end encryption. Your data stays yours.
          </p>
        </div>
      </div>
      <SecuritySection />
      <CtaSection />
    </>
  );
}
